import { CheckCircle2, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";
const CREAM_DEEP = "#F0EBE0";
const INK = "#1A1F2E";
const INK_MUTED = "#5A6478";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
type Brand = {
  name: string;
  spec: string;
  note: string;
  expertise: string[];
};
const BRANDS: Brand[] = [{
  name: "B&D Panelift",
  spec: "Most popular AU",
  note: "Australia's #1 sectional door. We stock matching panels, hinges, and rollers for every Panelift profile — Icon, Classic, Statesman, Vogue.",
  expertise: ["All Panelift profiles", "Colour-matched panels", "OEM hinges & rollers"]
}, {
  name: "Steel-Line",
  spec: "Premium Aus.",
  note: "Heavier-spec Australian-made sectional doors. Factory-trained on Steel-Line panel systems, weather seals, and balance hardware.",
  expertise: ["Steel-Line Therma-Range", "Custom panel matching", "Insulated door specialist"]
}, {
  name: "Centurion",
  spec: "Quality mid-range",
  note: "Common in newer Sydney builds. We service every Centurion sectional — Vantage, Boss, Eco-Plus.",
  expertise: ["Vantage / Boss / Eco-Plus", "Original-spec hardware", "Insulated panel options"]
}, {
  name: "Gliderol",
  spec: "Architectural",
  note: "Premium architect-spec sectional doors common in luxury Sydney homes. We carry replacement parts for Gliderol Series",
  expertise: ["R-Series / RDS-Series", "Premium finish matching", "Heavy-duty hardware"]
}, {
  name: "Hörmann",
  spec: "European import",
  note: "German-engineered sectional doors. We service Hörmann LPU and LTE ranges with OEM-grade parts.",
  expertise: ["LPU / LTE ranges", "European-spec parts", "Premium finish work"]
}, {
  name: "Universal / Other",
  spec: "Any brand",
  note: "Dominator, 4Ddoors, Eco-Doors, Newgate, Superlift — if it's a sectional door in Sydney, we either stock the parts or source within 48 hours.",
  expertise: ["Cross-brand inventory", "48hr sourcing", "Legacy door support"]
}];
export default function SectionalBrands() {
  return <section style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    padding: "120px 24px",
    fontFamily: FONT_BODY
  }}>
      {}
      <div aria-hidden style={{
      position: "absolute",
      top: 60,
      left: -40,
      fontFamily: FONT_HEAD,
      fontSize: "clamp(160px, 20vw, 280px)",
      fontWeight: 900,
      color: CREAM_DEEP,
      opacity: 0.55,
      letterSpacing: "-0.04em",
      lineHeight: 1,
      pointerEvents: "none",
      userSelect: "none",
      zIndex: 0
    }}>
        BRANDS
      </div>

      <div aria-hidden style={{
      position: "absolute",
      top: 80,
      right: 24,
      width: 120,
      height: 1,
      background: GOLD,
      zIndex: 1
    }} />

      <div style={{
      position: "relative",
      zIndex: 2,
      maxWidth: 1200,
      margin: "0 auto"
    }}>
        {}
        <div style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
        gap: 60,
        marginBottom: 72,
        alignItems: "end"
      }} className="sectional-brands-header">
          <div>
            <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 20
          }}>
              <span style={{
              width: 32,
              height: 1,
              background: GOLD
            }} />
              <span style={{
              fontFamily: FONT_BODY,
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              color: GOLD_DARK
            }}>
                03 / Sectional brands
              </span>
            </div>

            <h2 style={{
            fontFamily: FONT_HEAD,
            fontSize: "clamp(34px, 4.5vw, 56px)",
            fontWeight: 800,
            color: INK,
            lineHeight: 1.05,
            letterSpacing: "-0.025em",
            margin: 0
          }}>
              The right panel,{" "}
              <span style={{
              color: GOLD_DARK,
              fontStyle: "italic",
              fontWeight: 700
            }}>
                for every brand
              </span>
              <br />
              colour-matched perfectly.
            </h2>
          </div>

          <p style={{
          fontFamily: FONT_BODY,
          fontSize: 17,
          color: INK_MUTED,
          lineHeight: 1.6,
          margin: 0,
          maxWidth: 460,
          justifySelf: "end"
        }}>
            We don't substitute generic panels — every replacement matches the
            exact profile, colour, and embossing of your existing door. 150+
            panels in stock at Bass Hill.
          </p>
        </div>

        {}
        <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 0,
        border: `1px solid ${CREAM_DEEP}`,
        borderRadius: 4,
        overflow: "hidden",
        background: "#ffffff"
      }} className="sectional-brands-grid">
          {BRANDS.map((b, i) => <BrandCard key={i} brand={b} index={i} />)}
        </div>

        {}
        <div style={{
        marginTop: 56,
        padding: "32px 40px",
        background: "#ffffff",
        border: `1px solid ${CREAM_DEEP}`,
        borderLeft: `3px solid ${GOLD}`,
        borderRadius: 4,
        display: "flex",
        flexWrap: "wrap",
        gap: 24,
        alignItems: "center",
        justifyContent: "space-between"
      }}>
          <div>
            <div style={{
            fontFamily: FONT_BODY,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: GOLD_DARK,
            marginBottom: 8
          }}>
              Don't know your brand?
            </div>
            <div style={{
            fontFamily: FONT_HEAD,
            fontSize: 19,
            fontWeight: 600,
            color: INK,
            lineHeight: 1.3,
            letterSpacing: "-0.01em"
          }}>
              Send a photo of your door — we'll identify the brand and panel
              spec within minutes.
            </div>
          </div>

          <Link to="https://wa.me/61485000933?text=Hi%20Gold%20Garage%20Door%2C%20can%20you%20identify%20my%20sectional%20door%20brand%3F" newTab style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "14px 22px",
          background: NAVY,
          color: "#ffffff",
          fontFamily: FONT_HEAD,
          fontSize: 14,
          fontWeight: 700,
          borderRadius: 8,
          textDecoration: "none",
          whiteSpace: "nowrap",
          transition: "background 0.2s, transform 0.2s"
        }} onMouseEnter={e => {
          e.currentTarget.style.background = NAVY_LIGHT;
          e.currentTarget.style.transform = "translateY(-2px)";
        }} onMouseLeave={e => {
          e.currentTarget.style.background = NAVY;
          e.currentTarget.style.transform = "translateY(0)";
        }}>
            Send photo via WhatsApp
            <ArrowUpRight size={16} strokeWidth={2.5} />
          </Link>
        </div>
      </div>

      {}
      <style>{`
        @media (max-width: 1024px) {
          .sectional-brands-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 700px) {
          .sectional-brands-header {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
            align-items: start !important;
          }
          .sectional-brands-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>;
}
function BrandCard({
  brand,
  index
}: {
  brand: Brand;
  index: number;
}) {
  const isLastCol = (index + 1) % 3 === 0;
  const isLastRow = index >= 3;
  return <div className="sectional-brand-card" style={{
    position: "relative",
    padding: "36px 32px",
    background: "#ffffff",
    borderRight: isLastCol ? "none" : `1px solid ${CREAM_DEEP}`,
    borderBottom: isLastRow ? "none" : `1px solid ${CREAM_DEEP}`,
    cursor: "default",
    transition: "background 0.3s",
    minHeight: 280,
    display: "flex",
    flexDirection: "column"
  }} onMouseEnter={e => {
    e.currentTarget.style.background = CREAM;
  }} onMouseLeave={e => {
    e.currentTarget.style.background = "#ffffff";
  }}>
      <div style={{
      fontFamily: FONT_HEAD,
      fontSize: 12,
      fontWeight: 800,
      color: GOLD_DARK,
      letterSpacing: "0.15em",
      marginBottom: 16
    }}>
        {String(index + 1).padStart(2, "0")} / {brand.spec}
      </div>

      <h3 style={{
      fontFamily: FONT_HEAD,
      fontSize: 24,
      fontWeight: 800,
      color: INK,
      lineHeight: 1.1,
      letterSpacing: "-0.02em",
      margin: "0 0 14px"
    }}>
        {brand.name}
      </h3>

      <p style={{
      fontFamily: FONT_BODY,
      fontSize: 14,
      color: INK_MUTED,
      lineHeight: 1.55,
      margin: "0 0 24px",
      flex: 1
    }}>
        {brand.note}
      </p>

      <ul style={{
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: 8
    }}>
        {brand.expertise.map((item, i) => <li key={i} style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontFamily: FONT_BODY,
        fontSize: 13,
        color: INK,
        fontWeight: 500
      }}>
            <CheckCircle2 size={14} color={GOLD_DARK} strokeWidth={2.5} style={{
          flexShrink: 0
        }} />
            {item}
          </li>)}
      </ul>
    </div>;
}